'use strict';

// TODO: Remove from `core-js@4`
require('../modules/es.set.is-disjoint-from.v2');